"use client";

import { Icon } from "@iconify/react";
import { useTranslate } from "@tolgee/react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem } from "@/components/ui";
import { LANGUAGES } from "@/constants/languages";
import { useLanguage } from "@/context/language-context";
import { tolgee } from "@/lib/tolgee";
import type { Language } from "@/types/interfaces/language";
import { ToggleDropdownTrigger } from "./ToggleDropdownTrigger";
import type { ToggleTriggerAs } from "./types";
import { SELECTED_TOGGLE_SETTINGS } from "./constants";

const prefetchLanguage = (lang: Language) => {
  tolgee.loadRecord({ language: lang });
};

export type LanguageToggleProps = {
  triggerAs?: ToggleTriggerAs;
};

export const LanguageToggle = ({ triggerAs = "navbar" }: LanguageToggleProps) => {
  const { language, setLanguage } = useLanguage();
  const { t } = useTranslate();
  const currentOption = LANGUAGES.find((opt) => opt.value === language) ?? LANGUAGES[0];
  const menuAlign = triggerAs === "sidebar-header" ? "start" : "end";

  return (
    <DropdownMenu>
      <ToggleDropdownTrigger
        triggerAs={triggerAs}
        ariaLabel={t("languageoption.toggle")}
        icon={currentOption.icon}
      />
      <DropdownMenuContent align={menuAlign} className={SELECTED_TOGGLE_SETTINGS.dropdownClass}>
        {LANGUAGES.map((option) => (
          <DropdownMenuItem
            key={option.value}
            onMouseEnter={() => prefetchLanguage(option.value)}
            onClick={() => setLanguage(option.value)}
          >
            <Icon icon={option.icon} />
            {t(option.label)}
            {language === option.value && (
              <Icon
                icon={SELECTED_TOGGLE_SETTINGS.icon}
                className={SELECTED_TOGGLE_SETTINGS.classes}
              />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
